import { gql } from '@apollo/client';

export const GET_AFFILIATE_COMMISSION_PAYOUTS = gql`
  query GetAffiliateCommissionPayouts(
    $input: AffiliateCommissionPayoutsInput!
  ) {
    getAffiliateCommissionPayouts(input: $input) {
      total
      offset
      limit
      entities {
        salesCount
        commissionTotal
        user {
          id
          email
          firstName
          lastName
          slug
          storeDetails {
            id
            storeName
          }
        }
        streams {
          salesCount
          commission
          stream {
            id
            name
            scheduleDate
            store {
              id
              firstName
              lastName
              slug
            }
          }
        }
      }
    }
  }
`;
